import * as React from "react";
import { AnchorHTMLAttributes, memo, FC } from "react";
import get from "lodash/get";
import { Typography } from "@material-ui/core";

import { useRecordContext } from "ra-core";
import { InjectedFieldProps, PublicFieldProps, sanitizeFieldRestProps } from "react-admin";
import { RequestType } from "../../Enums/RequestType";
import { Link } from "react-router-dom";

const RefNoUrlField: FC<UrlFieldProps> = memo(props => {
  const { className, emptyText, source, ...rest } = props;
  const record = useRecordContext(props);
  const value = get(record, source);
  const resourcePath = record?.requestType === RequestType.PBH ? "pbhrequestorders" : "requestorders";
  const pathTo = `/${resourcePath}/${record?.requestOrderId}`;

  if (value == null) {
    return (
      <Typography component="span" variant="body2" className={className} {...sanitizeFieldRestProps(rest)}>
        {emptyText}
      </Typography>
    );
  }

  return <Link to={pathTo}>{value}</Link>;
});

RefNoUrlField.defaultProps = {
  addLabel: true,
};

RefNoUrlField.displayName = "UrlField";

export interface UrlFieldProps extends PublicFieldProps, InjectedFieldProps, AnchorHTMLAttributes<HTMLAnchorElement> {}

export default RefNoUrlField;
